<template>
    <div
        class="tw-select-none tw-border tw-shadow-sm"
        :class="{
            'tw-border-eventwise/40 tw-bg-eventwise tw-text-white': props.type === 'is-primary',
            'tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-800': props.type === 'is-success',
            'tw-border-amber-200 tw-bg-amber-50 tw-text-amber-800': props.type === 'is-warning',
            'tw-border-red-200 tw-bg-red-50 tw-text-red-800': props.type === 'is-danger',
            'tw-border-sky-200 tw-bg-sky-50 tw-text-sky-800': props.type === 'is-info',
            'tw-border-gray-700 tw-bg-gray-800 tw-text-white': props.type === 'is-dark',
            'tw-border-gray-200 tw-bg-gray-50 tw-text-gray-700': !props.type,
            'tw-w-full tw-rounded-none': fullWidth,
            'tw-rounded-xl': !fullWidth,
            'tw-px-2.5 tw-py-2 tw-text-center tw-text-xs': condensed,
            'tw-py-3 tw-px-4': !condensed,
            'tw-sticky tw-top-0 tw-z-[100]': sticky,
            'tw-flex tw-items-center tw-gap-3': icon || $slots.actions,
        }"
    >
        <div v-if="icon" class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
            <span
                class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-current/10"
            >
                <i :class="defaultIcon" class="tw-text-xl"></i>
            </span>
            <div class="tw-min-w-0 tw-flex-1 tw-leading-5"><slot /></div>
        </div>
        <div v-else class="tw-min-w-0 tw-flex-1 tw-leading-5"><slot /></div>
        <div v-if="$slots.actions" class="tw-shrink-0"><slot name="actions" /></div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    type: {
        type: [String, null],
        default: null,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    condensed: {
        type: Boolean,
        default: false,
    },
    sticky: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: [Boolean, String],
        default: false,
    },
});

const defaultIcon = computed(() => {
    return 'mdi ' + (props.icon ? props.icon : 'mdi-sync-alert');
});
</script>
